import RestApi from './RestApi';

class AuthenticationClient {

  static loginOktaUser(email) {
    const api = new RestApi();
    return api.GET('/authentication/LoginOktaUser?email=' + encodeURIComponent(email)).then(response => {
      return response;
    });
  }

  static loginUser(email,password) {
    const api = new RestApi();
    return api.GET('/authentication/LoginUser?email=' + encodeURIComponent(email) + '&password=' + encodeURIComponent(password)).then(response => {
      return response;
    });
  }

  static registerUser(params) {
    const api = new RestApi();
    return api.POST('/authentication/RegisterUser',params)
    .then(response => { 
        return response;
    });
  }

  static addUser(params) {
    const api = new RestApi();
    return api.POST('/authentication/AddUser',params)
    .then(response => { 
        return response;
    });
  }

  static fetchAllUsers(adminID) {
    const api = new RestApi();
    return api.GET('/authentication/GetAllUserRecords?adminID=' + encodeURIComponent(adminID)).then(response => {
      return response;
    });
  }
  
  static fetchUserRecord(id) {
    const api = new RestApi();
    return api.GET('/authentication/GetUserRecord?id=' + encodeURIComponent(id)).then(response => {
      return response;
    });
  }

  static updateAccountStatus(params) {
    const api = new RestApi();
    return api.POST('/authentication/UpdateAccountStatus',params)
    .then(response => { 
        return response;
    });
  }
  
  static updateWriteAccess(params) {
    const api = new RestApi();
    return api.POST('/authentication/UpdateWriteAccess',params)
    .then(response => { 
        return response;
    });
  }

    
  static updateUserBaseList(params) {
    const api = new RestApi();
    return api.POST('/authentication/updateUserBaseList',params)
    .then(response => { 
        return response;
    });
  }

  
}

export default AuthenticationClient;